// extracted by mini-css-extract-plugin
export default {"header":"answer-list-loading_header__SPDt0","body":"answer-list-loading_body__V+Xss"};